import { iStoreCaseConfiguration } from '@/Interfaces/storeCaseConfiguration';
import { getCaseDataByModel, getCaseItemPrototypeById, getDrawerSeparatorPrototypeById } from '@/libs/libGetters';

export function getSpecification(configurations: Array<iStoreCaseConfiguration>) {
    const result: Record<string, any> = {};

    for (const index in configurations) {
        const configuration = configurations[index];
        // Добавляем шкаф
        if (configuration.selectedCaseModel) {
            const caseData = getCaseDataByModel(configuration.selectedCaseModel);
            if (!caseData) {
                console.error('Неверная модель шкафа в проекте');
            } else if (!caseData.xmlId) {
                console.error('Отсутствует xmlID шкафа');
            } else if (result[caseData?.xmlId]) {
                result[caseData.xmlId] += 1;
            } else {
                result[caseData.xmlId] = 1;
            }
        }

        // Добавляем комплектующие
        configuration.caseItems.forEach(item => {
            const itemPrototype = getCaseItemPrototypeById(item.prototypeId);
            if (!itemPrototype) {
                console.error('Неверный prototypeID объекта');
            } else if (!itemPrototype.xmlId) {
                console.error('Отсутствует xmlID объекта');
            } else if (result[itemPrototype.xmlId]) {
                result[itemPrototype.xmlId] += 1;
            } else {
                result[itemPrototype.xmlId] = 1;
            }
        });

        // Добавляем разделители ящиков
        configuration.drawerSeparators.forEach(separator => {
            const separatorPrototype = getDrawerSeparatorPrototypeById(separator.prototypeId);
            if (!separatorPrototype) {
                console.error('Неверный prototypeID разделителя ящика');
            } else if (!separatorPrototype.xmlId) {
                console.error('Отсутствует xmlID разделителя ящика');
            } else if (result[separatorPrototype.xmlId]) {
                result[separatorPrototype.xmlId] += 1;
            } else {
                result[separatorPrototype.xmlId] = 1;
            }
        });
    }

    // console.log('!specification:', result);
    return result;
}
